// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"05593109","977":"0ad349cf"}[chunkId] + ".chunk.js";
};